import {
    SEND_EMAIL_WITH_RECOMMENDATIONS,
    SEND_EMAIL_WITH_RECOMMENDATIONS_SUCCESS,
    SEND_EMAIL_WITH_RECOMMENDATIONS_FAILURE,
} from '../../constants';

import { sendEmailWithRecommendationsService } from '../../services/sendEmail';

export const sendEmailWithRecommendationsSuccess = (payload) => ({
    type: SEND_EMAIL_WITH_RECOMMENDATIONS_SUCCESS,
    payload,
});

export const sendEmailWithRecommendationsFailure = () => ({
    type: SEND_EMAIL_WITH_RECOMMENDATIONS_FAILURE,
});

export const sendEmailWithRecommendations =
    (payload) => async (dispatch) => {
        try {
            dispatch({
                type: SEND_EMAIL_WITH_RECOMMENDATIONS,
                isLoading: true,
            });
            const sendEmailRecommendationsResponse =
                await sendEmailWithRecommendationsService(payload);
            dispatch(
                sendEmailWithRecommendationsSuccess(
                    sendEmailRecommendationsResponse,
                ),
            );
        } catch (err) {
            dispatch(sendEmailWithRecommendationsFailure());
        }
    };
